import {Component, OnInit} from '@angular/core';
import {ConfirmModalComponent} from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';
import {DialogService} from 'src/app/core/components/dialog/dialog.service';
import {FormConfiguration} from 'src/app/core/components/dynamic-form/models/form-config';
import {QuestionBase} from 'src/app/core/components/dynamic-form/models/question-base';

import {DocumentManagementService} from '../../services/document-management.service';
import {cardFilters, defaultFilterBody, formConfig} from '../../config/filters';
import {ViewManagerService} from '../../../core/services/view-manager-service';
import {ElaborationDocumentListRequest} from '../../models/elaboration-doc-list-request';
import {ElaborationDocument} from '../../models/elaboration-doc';
import {ElaborationDocumentListResponse} from '../../models/elaboration-doc-list-response';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: ' main [document-management-dashboard]',
  templateUrl: './document-management-dashboard.component.html',
  styleUrls: ['./document-management-dashboard.component.css'],
  host: {'[attr.id]': '\'content\''},
})
export class DocumentManagementDashboardComponent implements OnInit {
  selectOrder : string = 'DESC';
  filterFields: QuestionBase[] = null;
  formConfiguration: FormConfiguration = null;
  elaborationResponse: ElaborationDocumentListResponse;
  uploadedElaborations: ElaborationDocument[] = []  // List of elaborations
  noElaborationsLoaded = false;
  cachedFilters: ElaborationDocumentListRequest = {} // keeps track and stores inserted filters
  resetCurrentPage: boolean = false;

  constructor(
    private documentService: DocumentManagementService,
    private dialog: DialogService,
    private _viewManager: ViewManagerService
  ) {

    this._viewManager.svuotaMenu();
  }

  ngOnInit() {
    this.cachedFilters.paging = {
      'from-row': 0,
      'max-rows-x-page': 10,
      orders: [{fieldEntityName: null, orderClause: 'DESC'}]
    }
    this.getDocumentStatusList();
    this.getListOfDocumentsElaborations().subscribe();
  }

  private getListOfDocumentsElaborations(filters?: ElaborationDocumentListRequest): Observable<ElaborationDocumentListResponse>{
    return this.documentService.getElaborationDocumentList(filters || defaultFilterBody).pipe(
      tap(response => {
        this.elaborationResponse = response
        this.uploadedElaborations = response.elaborazioni
        if (response.elaborazioni.length < 1) {
          this.noElaborationsLoaded = true;
          this.uploadedElaborations = []
        } else {
          this.noElaborationsLoaded = false;
          this.uploadedElaborations = response.elaborazioni;
        }
      })
    );
  }

  private getDocumentStatusList() {
    this.documentService.getStatusDocumentElaboration().subscribe(
      response => {
        const index = cardFilters.findIndex(i => i.key === 'stato');
        const remap: Array<{ key?: string, value?: string, label: string }> = []
        response.forEach(el => {
          remap.push({
            key: el.id,
            label: el.label,
            value: el.label
          })
        })
        cardFilters[index].options = remap;
        this.filterFields = cardFilters;
        this.formConfiguration = formConfig
      }
    );
  }

  // onChangePage(event: number) {
  //   this.updateCachedFilters(event);
  //   const body = this.filterBodyGenerator();
  //   this.getListOfDocumentsElaborations(body).subscribe();

  // }

  // updateCachedFilters(event: number) {
  //   this.cachedFilters.cntParam = event;
  //   this.cachedFilters.paging['from-row'] = event * this.cachedFilters.paging['max-rows-x-page'];
  //   this.cachedFilters.paging['max-rows-x-page'] = this.cachedFilters.paging['max-rows-x-page'];
  //   this.resetCurrentPage = false;
  // }

  // onSelectItemsPerPage(event: number) {
  //   this.cachedFilters.paging['from-row'] = this.cachedFilters.paging['from-row']
  //   this.cachedFilters.paging['max-rows-x-page'] = event
  //   const body = this.filterBodyGenerator()
  //   this.getListOfDocumentsElaborations(body).subscribe();
  // }

  onRemoveElaboration(idElaborazione: string, titolo: string) {
    const ref = this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: 'Sei sicuro di voler eliminare l\'elaborazione' + ' ' + '<b>' + titolo + '<b>' + '?',
          data: [],
        },
        style: {
          width: '30%',
        },
        title: 'Eliminazione Elaborazione',
      }
    })
    ref.afterClosed.pipe(
      filter(response => response.modalEvent),
      switchMap(() => this.deleteSingleElaboration(idElaborazione)),
      switchMap(() => this.getListOfDocumentsElaborations(this.filterBodyGenerator()))
    ).subscribe();
  }

  private deleteSingleElaboration(idElaborazione: string): Observable<{id: string;}> {
    return this.documentService.deleteElaboration(idElaborazione).pipe(
      tap(res => {
        if (res.id) {
          const index = this.uploadedElaborations.findIndex(
            (el) => el.idElaborazione === res.id
          );
          if (index > -1) {
            this.uploadedElaborations.splice(index, 1);
          }
          if (this.uploadedElaborations.length < 1) this.noElaborationsLoaded = true;
        }
      })
    );
  }

  onFilterSubmission(event) {
    this.cachedFilters.paging = {
      "from-row":0,
      "max-rows-x-page": this.cachedFilters.paging['max-rows-x-page'],
      orders:[{fieldEntityName:"dataCreazione", orderClause: this.selectOrder}]
    }
    this.cachedFilters.dataCreazioneElaborazione = event.dataCreazione
    this.cachedFilters.idStatoElaborazione = event.stato === 'null' ? null : event.stato
    this.cachedFilters.titolo = event.titolo
    const body: ElaborationDocumentListRequest = this.filterBodyGenerator()
    this.getListOfDocumentsElaborations(body).subscribe();
    this.resetCurrentPage = true;
  }

  onFilterReset() {
    let pageNum = this.cachedFilters.paging['max-rows-x-page'];
    this.cachedFilters = {}
    this.cachedFilters.paging = {
      'from-row': 0,
      'max-rows-x-page': pageNum,
      orders: [{fieldEntityName: 'dataCreazione', orderClause: 'DESC'}]
    }
    this.selectOrder = 'DESC';
    // this.resetCurrentPage = true;
  }

  // onChangeDocumentsOrder(event) {
  //   this.cachedFilters.paging.orders[0].orderClause = event.target.value
  //   let body: ElaborationDocumentListRequest = this.filterBodyGenerator()
  //   this.getListOfDocumentsElaborations(body)
  // }

  filterBodyGenerator(): ElaborationDocumentListRequest {
    const body: ElaborationDocumentListRequest = {
      titolo: this.cachedFilters.titolo || null,
      dataCreazioneElaborazione: this.cachedFilters.dataCreazioneElaborazione || null,
      idStatoElaborazione: this.cachedFilters.idStatoElaborazione || null,
      parameters: {},
      paging: {
        'from-row': this.cachedFilters.paging['from-row'] || 0,
        'max-rows-x-page': this.cachedFilters.paging['max-rows-x-page'] || 10,
        orders: [
          {
            fieldEntityName: 'dataCreazione',
            orderClause: this.cachedFilters.paging ? this.cachedFilters.paging.orders[0].orderClause : 'DESC'
          }
        ]
      },
      cntParam: this.cachedFilters.cntParam || 0
    }
    return body;
  }

  onRefresh(pagination: Pagination){
    this.cachedFilters.cntParam = pagination.getCurrentPage();
    this.cachedFilters.paging['from-row'] = pagination.getFromIndex();
    this.cachedFilters.paging['max-rows-x-page'] = pagination.getItemsPerPage();
    const body: ElaborationDocumentListRequest = this.filterBodyGenerator()
    this.getListOfDocumentsElaborations(body).subscribe();
    this.resetCurrentPage = false;
  }

}
